import React, { useCallback } from 'react';
import { Input, Label, Tooltip } from '@iwoca/orion';
import { useFormContext } from 'react-hook-form';
import { TSignupFormData } from '../SignupForm/SignupForm';
import styles from '../SignupForm/SignupForm.module.css';

export const TurnoverInput = () => {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<TSignupFormData>();

  /** TODO: Replace this with Orion currency type when available with fix (e.g. format onBlur and defaultValue). */
  const formatCurrency = useCallback(() => {
    const amount = watch('last12MonthsTurnover')?.replace(/[^0-9]+/g, '');
    if (!amount) return '';

    return parseInt(amount).toLocaleString();
  }, [watch]);

  return (
    <>
      <div className={styles.labelWithTooltip}>
        <Label htmlFor="last12MonthsTurnover">Last 12 months turnover</Label>
        <Tooltip content="If they have been trading for less than a year, enter the total turnover to date." />
      </div>
      <Input
        {...register('last12MonthsTurnover')}
        value={formatCurrency()}
        id={'last12MonthsTurnover'}
        type="text"
        iconLeft="pound"
        error={
          errors?.last12MonthsTurnover?.message &&
          errors.last12MonthsTurnover.message
        }
      />
    </>
  );
};
